import { render, staticRenderFns } from "./complianceSelfInspection.vue?vue&type=template&id=3a0d05d0"
import script from "./complianceSelfInspection.vue?vue&type=script&lang=js"
export * from "./complianceSelfInspection.vue?vue&type=script&lang=js"
import style0 from "./complianceSelfInspection.vue?vue&type=style&index=0&id=3a0d05d0&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports